import { createReducer, on } from '@ngrx/store';
import { Campaign } from '@core/models/campaign.model';
import { CampaignFilters } from '@core/services/facades/campaign.facade';
import * as CampaignActions from './campaign.actions';

export interface CampaignState {
    pages: { page: number; data: Campaign[] }[];
    campaigns: Campaign[];
    selectedCampaign: Campaign | null;
    filters: CampaignFilters;
    loading: boolean;
    loaded: boolean;
    error: string | null;
    visiblePageIndex: number;
    listScrollPosition: number;
}

export const initialState: CampaignState = {
    pages: [],
    campaigns: [],
    selectedCampaign: null,
    filters: {},
    loading: false,
    loaded: false,
    error: null,
    visiblePageIndex: 0,
    listScrollPosition: 0,
};

export const campaignReducer = createReducer(
    initialState,

    // Load campaigns
    on(CampaignActions.loadCampaigns, (state) => ({
        ...state,
        loading: true,
        error: null,
    })),

    on(CampaignActions.loadCampaignsSuccess, (state, { pages }) => ({
        ...state,
        pages: pages,
        campaigns: pages.reduce((allCampaigns, page) => {
            return [...allCampaigns, ...page.data];
        }, [] as Campaign[]),
        loading: false,
        loaded: true,
        error: null,
    })),

    on(CampaignActions.loadCampaignsFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error,
    })),

    // Load single campaign
    on(CampaignActions.loadCampaign, (state) => ({
        ...state,
        loading: true,
        error: null,
    })),

    on(CampaignActions.loadCampaignSuccess, (state, { campaign }) => ({
        ...state,
        selectedCampaign: campaign,
        loading: false,
        error: null,
    })),

    on(CampaignActions.loadCampaignFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error,
    })),

    // Filters
    on(CampaignActions.setFilters, (state, { filters }) => ({
        ...state,
        filters,
    })),

    on(CampaignActions.clearFilters, (state) => ({
        ...state,
        filters: {},
    })),

    on(CampaignActions.searchCampaigns, (state, { searchTerm }) => ({
        ...state,
        filters: { ...state.filters, searchTerm },
    })),

    on(CampaignActions.invalidateCampaigns, (state) => ({
        ...state,
        loaded: false,
        visiblePageIndex: 0,
    })),

    on(CampaignActions.resetCampaigns, () => initialState),

    on(CampaignActions.showNextCampaignsPage, (state) => ({
        ...state,
        visiblePageIndex: state.visiblePageIndex + 1,
    })),

    on(CampaignActions.setCampaignListScrollPosition, (state, { position }) => ({
        ...state,
        listScrollPosition: position,
    })),
);
